module.exports = __webpack_public_path__ + "img/PL00257.74e806f7.png";